export const molliePos = {
  oAuthFlowHelp: "Meinen Account autorisieren",
  authSuccess: "Authentifizierung erfolgreich",
  installationTitle: "Installation der Connect Mollie POS App",
  installAction: "App installieren",
  molliePos: "Zuweisung von Xentral POS-Projekt zu Mollie-Terminals"
};
